import React from 'react';

// UI
import { ProjectAddAccountsField } from '../../../../../../app/layout/Projects/ProjectAddMembersField';
import { Typography } from '@cube3/cubicle/src/core/atoms/Typography';
import { VBox } from '@cube3/cubicle/src/core/templates/layout/Flex';

export interface MemersPickerProp {
  label?: string;
  form: string;
  inputFieldPlaceholder?: string;
  autoFocus?: boolean;
  excludedAccounts?: string[];
}

export const WorkspaceTeamMembersPicker = (props: MemersPickerProp) => {
  const {
    form,
    //  clearEmailInput,
    label,
    autoFocus = false,
    excludedAccounts
  } = props;

  return (
    <VBox gap={8} style={{ marginTop: 24 }}>
      {label && (
        <Typography colorVariant="02" weight="body">
          {label}
        </Typography>
      )}
      <ProjectAddAccountsField
        form={form}
        excludedAccounts={excludedAccounts}
        autoFocus={autoFocus}
        scrollbarHeight={300}
      />
    </VBox>
  );
};
